export enum DummyImageSize {
    small,
    medium,
    large
}
